import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { Tooltip } from '../../../../scripts/components/moderation-v2/sharable/components/Tooltip';
import { CopyIcon, KeyIcon } from '../../../../scripts/icons';
import { Badge } from '../../../../scripts/components/common/badge';
import { Spinner } from '../../../../scripts/components/moderation-v2/comments-and-posts/dashboard/components';
import { showToast } from '../../../../components/toast/toastSlice';

import styles from './AccessToken.module.scss';

interface AccessTokenProps {
  accessToken: string;
  isActive: boolean;
  isActivating: boolean;
  onActivate: () => void;
}

export function AccessToken(props: AccessTokenProps) {
  const { accessToken, isActivating, isActive, onActivate } = props;

  const dispatch = useDispatch();

  const onCopy = () => {
    navigator?.clipboard?.writeText(accessToken);

    dispatch(showToast({ type: 'success', message: 'Copied to clipboard' }));
  };

  const onActivateClick = () => {
    if (!isActivating) {
      onActivate();
    }
  };

  return (
    <>
      <div className={styles.titleContainer}>
        <span className={styles.title}>Access Token</span>
        <Badge
          label={isActive ? 'Active' : 'Suspended'}
          color={isActive ? '#35B940' : '#DB3737'}
          type="outlined"
        />
      </div>
      <div className={styles.accessTokenContainer}>
        <span className={styles.accessToken}>{accessToken}</span>
        {!isActive && (
          <button
            className={classNames(styles.button, styles.activateButton, {
              [styles.disabled]: isActivating
            })}
            onClick={onActivateClick}
          >
            {isActivating ? (
              <>
                <Spinner size="normal" spinnerClassName={styles.spinner} /> {'Activating '}
              </>
            ) : (
              <>
                <KeyIcon /> {'Activate'}
              </>
            )}
          </button>
        )}
        <Tooltip title={'Copy to clipboard'}>
          <button className={classNames(styles.button, styles.copyButton)} onClick={onCopy}>
            <CopyIcon />
          </button>
        </Tooltip>
      </div>
    </>
  );
}
